import React, { Suspense, useLayoutEffect, useState } from "react";
import { withAlert } from "react-alert";
import { withTranslation } from "react-multi-lang";
import "overlayscrollbars/css/OverlayScrollbars.css";
import { Servicecalls } from "../../../custom_functions/Functions";
import { updatecontrolrights } from "../../../redux_store/actions";
import store from "../../../redux_store/store";

const Vieworder = React.lazy(() => import("./../../orders/Vieworder"));
export const orderviewhashContext = React.createContext<any>(null);

const PViewerorder = (props: any) => {

    const [rights, setRights] = useState<any>(null);
    console.log("viewOrder")
    sessionStorage.removeItem("__lock");
    // localStorage.removeItem("linkedorder");
    sessionStorage.setItem("_OrderView", "1");
    let hashdetails = undefined;
    if (props.location.hash !== undefined && props.location.hash.length > 0) {

        hashdetails = JSON.parse(JSON.stringify(props.location.hash.substring(1, props.location.hash.length).replaceAll("%22", '"')));
        if (hashdetails.includes("%7B") && hashdetails.includes("%7D")) {
            hashdetails = hashdetails.replaceAll("%7B", "{").replaceAll("%7D", "}");
        }
        if (hashdetails.includes("%7b") && hashdetails.includes("%7d")) {
            hashdetails = hashdetails.replaceAll("%7b", "{").replaceAll("%7d", "}");
        }
    }


    const Getuserrights = async (passObjDet: any) => {
        let response = await new Promise((resolve, reject) => {
            let ELNurl = (window as any).appUrl.ELN;
            Servicecalls(
                "" + ELNurl + "/User/GetUserRightsonUser",
                passObjDet,
                (res: any) => {
                    store.dispatch(updatecontrolrights(res));
                    resolve(res);
                },
                (error: any) => {
                    reject(error);
                }
            );
        });
        return response;
    }

    useLayoutEffect(() => {
        const fetchData = async () => {
            let linkorderstring = localStorage.getItem("linkedorder");
            if (linkorderstring) {
                let linkorderdata = JSON.parse(linkorderstring);
                // let ELNurl = (window as any).appUrl.ELN;
                let passObjDet = {
                    usercode: linkorderdata?.user?.usercode,
                    lsusergroup: {
                        usergroupcode: linkorderdata?.user?.lsusergroup?.usergroupcode,
                        usergroupname: linkorderdata?.user?.lsusergroup?.usergroupname,
                    },
                };
                sessionStorage.setItem("Token", linkorderdata.token);
                sessionStorage.setItem("tenantid", linkorderdata.tenantid);
                sessionStorage.setItem("azuretoken", linkorderdata.azuretoken);
                sessionStorage.setItem("tenantdomain", linkorderdata.tenantdomain);
                sessionStorage.setItem("ActiveNewTab", "1");
                sessionStorage.setItem("idletime", linkorderdata.idletime);
                let rights = await Getuserrights(passObjDet);
                setRights(rights);
                // console.log("kumu");
                // Handle the fetched user rights data here
            }
        };

        fetchData(); // Invoke the asynchronous function inside useLayoutEffect
    }, []); // Empty dependency array to run the effect only once


    return (<Suspense fallback={<div></div>}>
        {(rights?.rights !== null || hashdetails !== undefined) &&
            <orderviewhashContext.Provider value={hashdetails}>
                <Vieworder></Vieworder>
            </orderviewhashContext.Provider>
        }
    </Suspense>);
};
export default withAlert()(withTranslation(PViewerorder));